const stripTags = (value) => {
    return !/(<([^>]+)>)/.test(value);
}
const required = (value) => {
    if (Array.isArray(value)) return !!value.length;
    if (value === undefined || value === null) return false;
    if (value === false) return true;
    if (value instanceof Date) return !isNaN(value.getTime())
    if (typeof value === 'object') {
      for (let _ in value) return true
      return false
    }
    return !!String(value).length
}
const min = (value, min) => {
    return !value || parseInt(value) >= parseInt(min);
}
const max = (value, max) => {
    return !value || parseInt(value) <= parseInt(max);
}
const minLength = (value, minLength) => {
    return !value || value.length >= parseInt(minLength);
}
const maxLength = (value, maxLength) => {
    return !value || value.length <= parseInt(maxLength);
}
const regex = (value, regex, flags = false) => {
    if (typeof regex === 'string')
        regex = flags ? new RegExp(regex.slice(1, -1), flags) : new RegExp(regex.slice(1, -1));
    return !value || !regex || regex.test(value);
}
const email = (value) => {
    let reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex(value, reg, 'i');
}
const complex = (value) => {
    let reg = /^\S*(?=\S{8,})(?=\S*[a-z])(?=\S*[A-Z])(?=\S*[\d])\S*$/;
    return regex(value, reg);
}
const url = (value) => {
    let reg = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/;
    return regex(value?.toLowerCase(), reg, 'i');
}
const ip = (value) => {
    let reg = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return regex(value, reg);
}

export const validation = (types = []) => {
  let rules = [(v) => stripTags(v) || 'الگو این فیلد معتبر نمی‌باشد'];
  if (!Array.isArray(types))
      types = [types];
  types.forEach(el => {
      el = el.split(':');
      if (el[0] == 'required' && (!el[1] || el[1] == 1))
          rules.push(v => required(v) || 'تكميل اين فيلد الزامي است');
      if (el[0] == 'min')
          rules.push(v => min(v, el[1]) || `حداقل مقدار این فیلد ${el[1]} است`);
      if (el[0] == 'max')
          rules.push(v => max(v, el[1]) || `حداکثر مقدار این فیلد ${el[1]} است`);
      if (el[0] == 'minLength')
          rules.push(v => minLength(v, el[1]) || `حداقل مقدار این فیلد ${el[1]} کاراکتر است`);
      if (el[0] == 'maxLength')
          rules.push(v => maxLength(v, el[1]) || `حداکثر مقدار این فیلد ${el[1]} کاراکتر است`);
      if (el[0] == 'regex')
          rules.push(v => regex(v, el[1]) || 'الگو این فیلد معتبر نمی‌باشد');
      if (el[0] == 'email')
          rules.push(v => email(v) || 'الگو این فیلد معتبر نمی‌باشد');
      if (el[0] == 'url')
          rules.push(v => url(v) || 'الگو این فیلد معتبر نمی‌باشد');
      if (el[0] == 'complex')
          rules.push(v => complex(v) || 'الگو این فیلد معتبر نمی‌باشد');
      if (el[0] == 'ip')
          rules.push(v => (Array.isArray(v) ? v.length == v.filter(x => ip(x)).length : ip(v)) || 'الگو این فیلد معتبر نمی‌باشد');
  })
  return rules;
}

export const useValidation = () => {
  return validation;
}

export default {
  install: (app) => {
    app.config.globalProperties.$validation = validation;
    app.provide('validation', validation);
  }
}
